var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup22252(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22252",
    "data-name": "Group 22252",
    transform: "translate(-628 -2045)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22251",
    "data-name": "Group 22251",
    transform: "translate(333 -781.999)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5653",
    "data-name": "Rectangle 5653",
    width: 85,
    height: 85,
    rx: 15,
    transform: "translate(295 2826.999)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_10132195_sim_card_line_icon",
    "data-name": "10132195_sim_card_line_icon",
    d: "M36.817,39.362V7.545A4.545,4.545,0,0,0,32.272,3H18.246a4.545,4.545,0,0,0-3.214,1.331l-8.7,8.7A4.545,4.545,0,0,0,5,16.246V39.362a4.54,4.54,0,0,0,4.539,4.545H32.273A4.544,4.544,0,0,0,36.817,39.362Z",
    transform: "translate(649.592 2064.046)",
    fill: "none",
    stroke: "#6d4eec",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup22252);
export default __webpack_public_path__ + "static/media/Group 22252.124f926aab998dfb216904e96dbd18ad.svg";
export { ForwardRef as ReactComponent };